import { FormControl, FormLabel, Switch } from '@chakra-ui/react'

import { useIsAdmin, useTeam, useUpdateTeam } from '@/react-query/team'

export const TeamVideoRecording = () => {
  const team = useTeam().data
  const updateTeam = useUpdateTeam()
  const isAdmin = useIsAdmin()

  if (!isAdmin) {
    return null
  }

  return (
    <FormControl display={'flex'} flexDirection={'column'} gap={2}>
      <FormControl display={'flex'} alignItems={'center'}>
        <Switch
          id="enable-video-recording"
          onChange={(event) => {
            event.preventDefault()
            const value = event.target.checked
            updateTeam.mutate({ enableVideoRecording: value })
          }}
          isChecked={team?.enableVideoRecording || false}
          size={'lg'}
          variant={'brand-black'}
        />
        <FormLabel htmlFor="enable-video-recording" mb="0" ml={'4'}>
          Enable video replays for new interviews
        </FormLabel>
      </FormControl>
    </FormControl>
  )
}
